import 'babel-polyfill'
import Vue, { PluginObject } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import translator from '@/utilities/translator'
import TreeMenu from '@/views/overview/TreeMenu.vue'
import axios, { AxiosResponse } from 'axios'

// Google analytics imports
import('vue-ua').then((module) => {
  Vue.use((module.default as PluginObject<{}>), {
    appName: 'Airlearn.nl',
    appVersion: '0.1',
    trackingId: 'UA-171451469-1',
    vueRouter: router
  })
})

const plugin = {
  install () {
    Vue.prototype.$text = translator
  }
}

Vue.use(plugin)

import('vue-youtube-embed').then((module) => {
  Vue.use(module.default as PluginObject<{}>)
})

// Important! Register recursive component globally
Vue.component('tree-menu', TreeMenu)
Vue.config.productionTip = false

axios.interceptors.response.use((response: AxiosResponse) => {
  return response
}, (error) => {
  if (error.response.status === 401) {
    store.commit('account/LOGOUT')
    router.push({ name: 'login' })
  }
  return Promise.reject(error)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
